<div>
    <ds-themed-header></ds-themed-header>
    <!-- Removed ds-themed-navbar -->
</div>
